import { ref } from 'vue'
import store from '@/store'
import Velocity from 'velocity-animate'
import { BASE_URL_REPORT } from '@/constants/config'

// Toggle mobile menu
const activeMobileMenu = ref(false)
const toggleMobileMenu = () => {
  activeMobileMenu.value = !activeMobileMenu.value
}

// Setup mobile menu
const linkTo = (menu, router) => {

  const user_details = store.state.user.currentUser
  if(menu.external == true) {
      let url = BASE_URL_REPORT + 'login' + '/' + window.btoa(user_details.id)
      window.open(url, '_blank');
    } else {

      if (menu.subMenu) {
        menu.activeDropdown = !menu.activeDropdown
      } else {
        activeMobileMenu.value = false
        router.push({
          name: menu.pageName
        })
      }
    }
}

const enter = (el, done) => {
  Velocity(el, 'slideDown', { duration: 300 }, { complete: done })
}

const leave = (el, done) => {
  Velocity(el, 'slideUp', { duration: 300 }, { complete: done })
}

export { activeMobileMenu, toggleMobileMenu, linkTo, enter, leave }
